var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-main',{staticStyle:{"padding":"0px"}},[_c('router-view',{on:{"checkLogin":_vm.checkLogin}})],1)],1),_c('Login',{ref:"login",on:{"loginSuccess":_vm.loginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }